import { cloneDeep } from 'lodash';

const state = {
  list: [],
  user: {},
  edit_user: {},
  orders: [],
  projects: [],
  payouts: [],
  search: '',
  authors: []
};

const getters = {
  list: (state) => {
    return state.list || [];
  },
  user: (state) => {
    return state.user || {};
  },
  edit_user: (state) => {
    return state.edit_user || {};
  },
  orders: (state) => {
    return state.orders || [];
  },
  projects: (state) => {
    return state.projects || [];
  },
  payouts: (state) => {
    return state.payouts || [];
  },
  search: (state) => {
    return state.search || '';
  },
  authors: (state) => {
    return state.authors || [];
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_USER(state, item) {
    state.user = cloneDeep(item);
    state.edit_user = cloneDeep(item);
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.list, index, Object.assign(state.list[index], cloneDeep(item)));
    } else {
      state.list.push(cloneDeep(item));
    }
  },
  EDIT_USER(state, item) {
    state.edit_user = cloneDeep(item);
  },
  DELETE_USER(state, id) {
    state.user = {};
    state.edit_user = {};
    const index = state.list.findIndex((x) => x.id === id);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
  },
  SET_USER_ORDERS(state, list) {
    state.orders = list;
  },
  SET_USER_PROJECTS(state, list) {
    state.projects = list;
  },
  SET_USER_PAYOUTS(state, list) {
    state.payouts = list;
  },
  ADD_USER_PAYOUT(state, item) {
    let index = state.list.findIndex((x) => x.id === item.userInfoId);
    if (index >= 0) {
      this._vm.$set(state.list[index], 'unpaid', 0);
    }
    if (state.user.id === item.userInfoId) {
      index = state.payouts.findIndex((x) => !x.paidDate);
      if (index >= 0) {
        this._vm.$set(state.payouts, index, item);
      }
    }
  },
  SET_SEARCH(state, val) {
    state.search = val;
  },
  SET_AUTHORS(state, list) {
    state.authors = list;
  }
};

const actions = {
  reset({ commit }) {
    commit('SET_LIST', []);
  },
  getUsers({ commit }, search) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`users/getUsers?search=${search}`)
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getContributors({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('users/getContributors')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDesigners({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('users/getDesigners')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveDesigner({ commit }, user) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('users/saveDesigner', user)
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  edit({ commit }, template) {
    commit('EDIT_USER', template);
  },
  set({ commit }, template) {
    commit('SET_USER', template);
  },
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`users/getUser?userId=${id}`)
        .then((response) => {
          commit('SET_USER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveRoles({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`users/saveRoles?userId=${req.userId}`, req.roleIds)
        .then((response) => {
          commit('SET_USER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  copyProject({}, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`users/copyProject?userId=${req.userId}&projectId=${req.projectId}`)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeUsername({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`users/changeUsername?userId=${req.userId}&newUsername=${req.newUsername}`)
        .then((response) => {
          commit('SET_USER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setPrintOnly({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`users/setPrintOnly?userId=${req.userId}`)
        .then((response) => {
          commit('SET_USER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetDefaultPassword({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`users/resetDefaultPassword?userId=${req.userId}`)
        .then((response) => {
          commit('SET_USER', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getOrders({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`users/getOrders?userId=${id}`)
        .then((response) => {
          commit('SET_USER_ORDERS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getProjects({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`users/getProjects?userId=${id}`)
        .then((response) => {
          commit('SET_USER_PROJECTS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPayouts({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`users/getPayouts?userId=${id}`)
        .then((response) => {
          commit('SET_USER_PAYOUTS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addPayout({ commit }, payout) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('users/addPayout', payout)
        .then((response) => {
          commit('ADD_USER_PAYOUT', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setSearch({ commit }, val) {
    commit('SET_SEARCH', val);
  },
  getAuthors({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('users/getAuthors')
        .then((response) => {
          commit('SET_AUTHORS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateAuthor({ commit }, author) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('users/updateAuthor', author)
        .then((response) => {
          commit('SET_AUTHORS', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
